import dayjs from "dayjs";

import type { ForeignNational } from "../../../api/types/foreignNational";
import {
  calendarDay,
  displayName,
  initialsOf
} from "../header/clientHeaderModel";

export { formatAddressLine } from "../header/clientHeaderModel";

export const getFullName = (
  fn: Pick<ForeignNational, "first_name" | "middle_name" | "last_name">
): string => displayName([fn.first_name, fn.middle_name, fn.last_name]);

export const initialsFromName = (name: string): string => initialsOf(name);

/** `MM/DD/YYYY`, or the fallback for empty / invalid input. */
export const formatMdY = (value?: string | null, fallback = "—"): string => {
  const d = calendarDay(value);
  return d ? dayjs(d).format("MM/DD/YYYY") : fallback;
};

/** `YYYY-MM-DD` for a native date input, or "" when unset / invalid. */
export const toDateInputValue = (iso?: string | null): string => {
  const d = calendarDay(iso);
  return d ? dayjs(d).format("YYYY-MM-DD") : "";
};

/**
 * ISO string pinned to noon UTC for a `YYYY-MM-DD` input value so the calendar
 * day survives timezone shifts; null when empty / invalid.
 */
export const dateInputToIso = (value: string): string | null => {
  const raw = value.trim();
  if (!raw) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
  if (!m) return null;
  const d = new Date(
    Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 12)
  );
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
};

export const normalizeText = (value: unknown): string =>
  typeof value === "string" ? value.trim() : "";

/** Age in whole years from a birthday, or null when unknown. */
export const ageFromBirthday = (iso?: string | null): number | null => {
  const d = calendarDay(iso);
  if (!d) return null;
  const years = dayjs().diff(d, "year");
  return years >= 0 ? years : null;
};
